export const CreditCardError = {
  CARD_DECLINED:
    "Please contact your card issuing bank to resolve the problem on online transaction. Alternatively, you can try to use a different card or other form of payment",
  EXPIRED_CARD:
    "Please input the correct expiration date. Or contact your issuing bank if you are certain that your card should still be active for the payment. Alternatively, you can try to use a different card or other form of payment.",
  INSUFFICIENT_BALANCE: "Payment was declined by the issuer because insufficient funds in the cardholder's account",
};
